import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})

export class PrivacyPolicyComponent {

   ngAfterViewInit() {
    // This executes right after the HTML hits the screen
    setTimeout(() => {
      // Fake a window resize event to force the browser to snap the header and banner together
      window.dispatchEvent(new Event('resize'));
    }, 50); // A 50ms delay is invisible to the user but enough for the browser
  }

}
